import React from 'react'

const Humourandsatire = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Match the following.</p>
        <p>transcendental ------ spiritual, nonphysical or mystical</p>
        <p>deplore ------ to feel or express strong disapproval of (something)</p>
        <p>absolve ------ set free from blame, guilt, or responsibility; release</p>
        <p>juju ------ a charm or fetish used by some West African people</p>
        <p>crude ------ natural state</p>
        <p>chronicle ------ a written record of historical events</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Find the contextual meanings of the following words from the text and then use them in sentences of your own.</p>
        <p>a. condemn : To express strong disapproval of something or someone.</p>
        <p>The teacher condemned cheating during the exam because it is unfair to other students.</p>
        <br/>
        <p>b. terror : A feeling of extreme fear or fright.</p>
        <p>The loud thunderstorm caused great terror among the children.</p>
        <br/>
        <p>c. Unbidden: Something that happens without being asked or invited; spontaneous or unexpected. </p>
          <p>Tears came to her eyes unbidden when she heard the sad news.</p>
          <br/>
          <p>d. persist : To continue firmly or stubbornly, especially despite difficulties or opposition.</p>
          <p>Even though the problem was hard, she persisted until she found the solution.</p>
          <br/>
          <p>e. devout : Showing deep religious feeling or commitment.</p>
          <p>She is a devout believer who visits the temple every week.</p>
          <br/>
          <p>f. banish : To send someone away from a place, usually as a punishment or to get rid</p>
          <p>The king decided to banish the traitor from the kingdom.</p>
          <br/>
          <p>g. creed : A set of beliefs or principles that guide a person or group.</p>
          <p>Their creed teaches kindness and honesty to everyone.</p>
          <br/>
          <p>h. hasten : To hurry or move quickly to do something.</p>
          <p>She hastened to finish her homework before the deadline.</p>
          <br/>
          <p>i. sober : Serious, thoughtful, and calm in behavior or attitude.</p>
          <p>After hearing the bad news, everyone had a sober and quiet conversation.</p>
          <br/>
          <p>j. scorn : A feeling or expression of strong dislike and disrespect.</p>
          <p>She looked at the broken toy with scorn because it was made cheaply.</p>
          <br/>
          <p>k. yearning : A strong feeling of wanting something or someone very much. </p>
          <p>After moving to a new city, she felt a deep yearning for her old friends.</p>
          <br/>
          <p>l. aloof : Not friendly or forthcoming; distant and reserved in manner.</p>
          <p>He stayed aloof from the argument, not wanting to get involved.</p>
          <br/>
          <p>m. swarthy : Having a dark complexion or skin tone.</p>
          <p>The traveler had a swarthy face from spending many months under the hot sun.</p>
          <br/>
          <p>n. humbler : More modest or less proud; having a low or simple status.</p>
          <p>Despite becoming successful, he always remembered his humbler beginnings.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Trace the origins of each of the following words finding such explanations in a dictionary or the Internet. Then make sentences by using each word.</p>
        <strong>Minatory</strong>
        <p>Origin: From Latin minatorius</p>
        <p>Meaning: Threatening</p>
        <p>The minatory warning signs kept people away from the dangerous cliffs.</p>
        <strong>Placated</strong>
        <p>Origin: From Latin placare</p>
        <p>Meaning: To make somebody less angry or upset</p>
        <p>The mother placated her crying child with a warm hug.</p>
        <strong>Cajoled</strong>
        <p>Origin: From French cajoler</p>
        <p>Meaning: To persuade someone gently or by flattery</p>
        <p>He cajoled his friends into helping him with the project.</p>

        <strong>Antedates</strong>
        <p>Origin: From Latin ante </p>
        <p>Meaning: To occur earlier than something else; to predate</p>
        <p>The old manuscript antedates many modern books on the same topic.</p>

        <strong>Proliferated</strong>
        <p>Origin: From Latin prolifer</p>
        <p>Meaning: To increase greatly or multiply rapidly</p>
        <p>Social media platforms have proliferated rapidly in the last decade.</p>

        <strong>Philter</strong>
        <p>Origin: From Greek philtron </p>
        <p>Meaning: A magical tonic or love potion</p>
        <p>In the story, the witch gave the prince a mysterious philter to win the princess's heart.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>D. List any five words found in an English dictionary beginning with the prefix 'super-' What common meaning do all of these words share? How do the words in your list change meaning if you eliminate the prefix?</p>
        <p>Supernatural-Beyond what is natural or explainable by the laws of nature; related to magic or spirits.</p>
        <br/>
        <p>Natural- Existing in or caused by nature; normal or usual.</p>
        <p>Superstar- A very famous and successful person, especially in entertainment or sports.</p>
        <br/>
        <p>star- A celestial body that shines in the sky; a famous or outstanding person.</p>
        <br/>
        <p>Supermarket- A large store where many different types of food and goods are sold. </p>
        <br/>
        <p>Market- A place where people buy and sell goods; can be a physical or virtual place.</p>
        <br/>
        <p>Superhero- A fictional character with extraordinary powers who fights evil.</p>
        <br/>
        <p>Hero- A person admired for courage, achievements, or noble qualities.</p>
        <br/>
        <p>Superintended- To oversee or be in charge of something.</p>
        <br/>
        <p>Intended- Planned or meant for a particular purpose.</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer these questions.</p>
        <p className='question'>a. According to the author, what are the four types of superstition?</p>
        <p>= According to the author, the four types of superstition are: Vain Observances, Divination, Idolatry, and Improper Worship of the True God.</p>
        <p className='question'>b. Which language is the word 'superstition' derived from? What does it mean?</p>
        <p>= The word 'superstition' is derived from the Latin word 'superstitio', which comes from 'superstare', meaning “to stand over in awe or fear.” It refers to standing in terror or excessive fear of the deity.</p>
        <p className='question'>c. How do psychologists understand superstition?</p>
        <p>= Psychologists think superstition is a habit or behavior that people feel forced to do, even if it doesn't make sense. It continues even in people who have mental problems like anxiety.</p>
        <p className='question'>d. How does superstition differ from religion?</p>
        <p>= The difference between religion and superstition is that religion is based on faith shared by a community and involves worship of God or gods. 
          </p><p>Superstition, on the other hand, is based on fear or blind beliefs and involves rituals or practices that are not based on reason or true faith.</p>
        <p className='question'>e. What is the belief of some people in Middle Europe about sneezing?</p>
        <p>Some people in Middle Europe believe that when a person sneezes, their soul leaves the body for a moment, so others quickly bless them to protect them from harm.</p>
        <p className='question'>f. In the author's view, why are people so fascinated about superstition?</p>
        <p>= In the author's view, people are fascinated by superstition because they want to know their future and feel like they have some control over it.</p>
      </div>
      <hr/>
      <div>
        <h3>Critical Thinking</h3>
        <p className='question'>a. What is the key takeaway of this essay? Do you think that this essay is satirical? Why?</p>
        <p>= The key takeaway of the essay is that people, whether educated or uneducated, knowingly or unknowingly follow superstitions. Even the most logical and rational individuals often hold on to superstitious beliefs. The essayist suggests that many superstitions are so old and widespread that they likely come from deep within the human mind, unaffected by race, culture, or education.</p>
        <p>Yes, this essay is satirical. The author uses humor and irony to criticize people who fall victim to superstition despite their knowledge or status. For example, he mentions people throwing salt over their left shoulder after spilling it, avoiding walking under ladders, consulting the I Ching for university matters, and placing lucky items like coins or charms on desks during exams. These examples show how absurd and irrational some behaviors can be, even in modern settings. By pointing out these habits in a witty way, the author mocks how deeply rooted and silly superstitions can be.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Can education bring change in the belief of superstition? Present your arguments to support your answer.</p>
        <p>= Education can bring change in the belief of superstition, although it may not eliminate it completely. Educated individuals are generally more likely to rely on science and logic. For example, they are more likely to take a sick person to a hospital instead of calling a priest to drive out supposed evil spirits. Education helps people understand the real causes of diseases and other natural events, reducing the fear that often leads to superstition.
</p><p>
Superstitions are often born out of fear of the unknown. When people are educated, they gain knowledge that helps them understand what was once mysterious or frightening. As a result, their fear lessens, and so does their belief in superstitions. Education also improves critical thinking and decision-making skills, making people less likely to accept irrational beliefs.
</p><p>
However, while education has the power to reduce superstitions, it may not completely remove them. Some superstitions are deeply rooted in culture and emotion rather than ignorance. Even educated people can sometimes hold on to certain irrational beliefs. Therefore, education alone may not entirely erase superstition unless it is paired with open-mindedness and a willingness to question tradition.
</p><p>
In conclusion, education plays a major role in reducing superstitious beliefs by promoting knowledge and reasoning. It may not wipe out superstition entirely, but it certainly helps people think more critically and make more informed choices.</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p className='question'>a. Write an essay on superstitions that exists in your community in about 250 words.</p>
        <strong>Superstitions in My Community</strong>
        <p>Superstitions have existed in human society for thousands of years, and my community is no exception. Even today, many people around me believe in signs, omens, and rituals that have no scientific basis. These beliefs are often passed down from one generation to another and are followed without question.</p>
        <p>In my community, one common superstition is that if a cat crosses your path, it brings bad luck. People stop or change their route just because of this belief. Another popular one is the throbbing of the right or left eye, many think it signals either good or bad news. The cawing of a crow is believed to mean that a guest is coming, and meeting a sweeper early in the morning is thought to bring good luck.</p>
        <p>Sadly, during illness, some people still visit faith healers or "witch doctors" instead of going to hospitals. They believe the illness is caused by evil spirits or curses. This can delay proper treatment and make the condition worse.</p>
        <p>Most of these superstitions are based on fear and lack of scientific knowledge. While our elders may follow them out of habit or culture, it is important that the younger generation learns to question and think logically.</p>
        <p>We should respect traditions, but also work to build a society based on science, reason, and understanding. Education and awareness are key to reducing superstitious beliefs and promoting rational thinking.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. “Superstition is prevalent in every walk of life.” Argue for this statement.</p>
        <p>= Yes, superstition is found everywhere in life. People began believing in superstitions when they felt powerless against natural events and wanted explanations for things they could not control. Many superstitions also come from cultural traditions and social beliefs.</p>
        <p>For instance, in many communities, people believe that breaking a mirror brings seven years of bad luck. Similarly, the belief that walking under a ladder is unlucky is common in many cultures. In some places, spilling salt is thought to invite bad luck unless it is thrown over the left shoulder.</p>
        <p>In Nepal, many still believe that seeing a snake or a crow near the house is a sign of upcoming bad news or misfortune. In other parts of the world, people avoid opening umbrellas indoors because it is believed to cause bad luck.</p>
        <p>Even in modern times, some people avoid certain numbers or days when making important decisions, thinking that some dates are unlucky. For example, many avoid traveling or starting new projects on Fridays the 13th.</p>
        <p>These beliefs may not have any scientific explanation, but they continue to influence daily life. Despite progress in education and science, superstitions remain deeply rooted in many cultures, showing that they are truly prevalent in every aspect of life.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Put the verb into the correct form, present simple or present continuous.</p>
        <p>a. Nisha <u>speaks</u> (speak) English very well.</p>
        <p>b. Hurry up! We <u>are waiting</u> (wait) for you.</p>
        <p>c. Excuse me! <u>Do you speak</u> (you/speak) English?</p>
        <p>d. She <u>is having</u> (have) a shower in bathroom.</p>
        <p>e. How often <u>do you read</u> (you/read) a newspaper?</p>
        <p>f. I'm sorry, I <u>don't understand</u> (not/understand). Can you speak more slowly?</p>
        <p>g. You can turn off the radio. I <u>am not listening</u> (not/listen) to it.</p>
        <p>h. I usually <u>get up</u> (get up) at 5 o'clock every morning.</p>
        <p>i. Look! The river <u>is flowing</u> (flow) very fast.</p>
        <p>j. Amrita <u>does not seem</u> (not/seem) very happy at the moment.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Are the underlined verbs in the correct form? Correct them where necessary.</p>
        <p>a. Water boils at 100° C.</p>
        <p>= Water boils at 100° C.</p>
        <p>b. The water boils. Can you turn it off?</p>
        <p>= The water is boiling. Can you turn it off?</p>
        <p>c. I must go now. It gets late.</p>
        <p>= I must go now. It is geting late.</p>
        <p>d. This sauce's tasting really good.</p>
        <p>= This sauce tastes really good.</p>
        <p>e. I'm thinking this is your key.</p>
        <p>= I think this is your key.</p>
        <p>f. Are you believing in God?</p>
        <p>= Do you believe in God?</p>
        <p>g. I usually go to school on foot.</p>
        <p>= I usually go to school on foot.</p>
        <p>h. Look! That man tries to open the door of her car.</p>
        <p>= Look! That man is trying to open the door of her car.</p>
        <p>i. The moon is going round the earth.</p>
        <p>= The moon goes round the earth.</p>
        <p>j. I'm getting hungry. Let's go and eat.</p>
        <p>= I'm getting hungry. Let's go and eat.</p>
      </div>
    </div>
  )
}

export default Humourandsatire
